(() => {
  const CART_TRIGGER_SELECTOR = '[data-testid="cart-drawer-trigger"]';
  const CART_ICON_SELECTOR = '.header-actions__cart-icon';

  const getCartSectionIds = () => {
    const ids = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
      .map((node) => node.getAttribute('data-section-id'))
      .filter(Boolean);

    return [...new Set(ids)];
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });

    if (!response.ok) return null;
    return response.json();
  };

  const fetchSections = async (sectionIds) => {
    if (!Array.isArray(sectionIds) || sectionIds.length === 0) return {};

    const url = new URL(window.location.href);
    url.searchParams.delete('section_id');
    url.searchParams.set('sections', sectionIds.join(','));

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    });

    if (!response.ok) return {};

    const payload = await response.json();
    if (!payload || typeof payload !== 'object') return {};
    return payload;
  };

  const updateCartBadge = (itemCount, animate = true) => {
    const nextCount = Number(itemCount) || 0;
    const countText = nextCount > 99 ? '99+' : `${nextCount}`;

    document.querySelectorAll(CART_ICON_SELECTOR).forEach((icon) => {
      icon.classList.toggle('header-actions__cart-icon--has-cart', nextCount > 0);
    });

    document.querySelectorAll('.cart-bubble').forEach((bubble) => {
      bubble.classList.toggle('visually-hidden', nextCount <= 0);

      const countNode = bubble.querySelector('.cart-bubble__text-count');
      if (countNode instanceof HTMLElement) {
        if (nextCount > 0) {
          countNode.textContent = countText;
          countNode.classList.remove('hidden');
        } else {
          countNode.textContent = '';
          countNode.classList.add('hidden');
        }
      }

      if (animate) {
        bubble.classList.add('cart-bubble--animating');
        window.setTimeout(() => bubble.classList.remove('cart-bubble--animating'), 240);
      }
    });
  };

  const pulseCartTrigger = () => {
    const trigger = document.querySelector(CART_TRIGGER_SELECTOR) || document.querySelector(CART_ICON_SELECTOR);
    const pulseTarget = trigger?.closest('.header-actions__action') || trigger;

    if (!(pulseTarget instanceof HTMLElement)) return;
    pulseTarget.classList.remove('spot-cart-pulse');
    void pulseTarget.offsetWidth;
    pulseTarget.classList.add('spot-cart-pulse');
    window.setTimeout(() => pulseTarget.classList.remove('spot-cart-pulse'), 260);
  };

  const dispatchCartUpdate = (cart, sections, source) => {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: source || 'spot-cart-sync',
          data: {
            source: source || 'spot-cart-sync',
            itemCount: Number(cart?.item_count) || 0,
            sections: sections || {},
          },
        },
      })
    );
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
      return;
    }

    const trigger = document.querySelector(CART_TRIGGER_SELECTOR);
    if (trigger instanceof HTMLElement) {
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    }
  };

  const syncCartUI = async ({ source = 'spot-cart-sync', openDrawer = false, animateBadge = true, openDelay = 0 } = {}) => {
    const [cart, sections] = await Promise.all([
      fetchCart(),
      fetchSections(getCartSectionIds()),
    ]);

    if (!cart) return null;

    updateCartBadge(cart.item_count, animateBadge);
    dispatchCartUpdate(cart, sections, source);

    if (openDrawer) {
      window.setTimeout(() => {
        openCartDrawer();
      }, Math.max(0, Number(openDelay) || 0));
    }

    return { cart, sections };
  };

  const onCartTriggerClick = () => {
    syncCartUI({ source: 'spot-cart-trigger', openDrawer: false, animateBadge: false }).catch(() => null);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest(CART_TRIGGER_SELECTOR) : null;
    if (!trigger) return;
    onCartTriggerClick();
  });

  document.addEventListener('spot:cart-added', (event) => {
    const detail = event.detail || {};
    syncCartUI({
      source: detail.source || 'spot-custom-add',
      openDrawer: detail.openDrawer !== false,
      animateBadge: true,
      openDelay: detail.openDelay ?? 0,
    })
      .then(() => {
        pulseCartTrigger();
      })
      .catch((error) => {
        console.error(error);
      });
  });

  window.SpotCartSync = {
    syncCartUI,
    openCartDrawer,
    updateCartBadge,
  };
})();
